// Only published, equivalent pages belong in a group. Add Arabic entries after
// professional translation and product/local-service approval, never placeholders.
export const localeGroups = [[
  { language: 'en-PK', path: '/school-management-system' },
  { language: 'en-AE', path: '/school-management-system-uae' },
  { language: 'en-OM', path: '/school-management-system-oman' },
  { language: 'en-SA', path: '/school-management-system-saudi-arabia' },
]];
